import Vue from 'vue';
import Scrollspy from 'vue2-scrollspy';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.use(Scrollspy);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  created() {
    this.$store.dispatch('getMovies');
    this.$store.dispatch('getBanners');
    this.$store.dispatch('getSnacks');
  },
  render: h => h(App),
}).$mount('#app');
